import Mock from 'mockjs'

Mock.mock(/\/userList/, 'post', {
  code: 200,
  data: [
    {
      id: '@id',
      name: '@name',
      token: '@id'
    }
  ]
})
